import { useMutation } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { DefaultPlan } from "@modules/defaultPlans/types";
import { DefaultPlanFormValues } from "@modules/defaultPlans/validations";

import { createDefaultPlanService } from "./service";
import { UseCreateDefaultPlanMutationOptions } from "./types";

export function useCreateDefaultPlanMutation(
  options?: UseCreateDefaultPlanMutationOptions
) {
  const { open } = useNotification();

  return useMutation<DefaultPlan, ApiError, DefaultPlanFormValues>({
    mutationFn: createDefaultPlanService,
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
